<section class="promotion-reasons py-5">
    <div class="container-xl px-4">
        <h2 class="promotion-reasons__title text-center mb-5">
            {{ 'fe_coupon_promotions_reasons_title' | translate }}
        </h2>
        <div class="row g-4">
            <div class="col-12 col-lg-3" *ngFor="let reason of rentalReasons">
                <div
                    class="promotion-reasons__card h-100 p-lg-4 d-flex flex-row flex-lg-column align-items-center text-start text-lg-center"
                >
                    <img
                        class="promotion-reasons__card__icon"
                        [src]="reason.icon | cdn"
                        alt=""
                    />
                    <div>
                        <h3 class="promotion-reasons__card__title">
                            {{ reason.title | translate }}
                        </h3>
                        <p class="promotion-reasons__card__text mb-0">
                            {{ reason.text | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
